module.exports = __webpack_public_path__ + "media/authors/shawna-newman-horizontal-52b9f792.jpg";